import LoginPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/LoginPage";
import AccountSummaryPage from "../AccountSummaryPage";
import { BCMSStateManagerCRUD, useModel } from "bcms-react";
import Util from "classes/Util";

/**
 * @name Mabi23FirstTimeLogin
 * @returns {React.Component}
 * @description Component for the "First Time Login" page currently only used in MABI23.
 * The component was built so that the user is taken to a page that
 * already accounts for the "First Time Login" branding
 * option which is outside of MABI23.
 */
export default function Mabi23FirstTimeLogin(props) {
    const { branding } = useModel();
    const options = branding.options;

    // initalize a new BCMSStateManagerCRUD instance using the default page ui
    // updating the modal property
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "modal", "id" ], "FirstTimeLoginModal")
        .submit();

    if(options.first_time_login_abi22 === "true") {
        return <LoginPage ui={ ui } />;
    }
    else {
        Util.routeMabi("content/accountSummary");
    }
}